import './style.scss';
import psl_actions from '../../libs/psl_actions.js';
import data from "../../data.js";
import state from '../../state.js';

import Popup from '../popup/component.js';
import PopupViewer from '../popup_viewer/component.js';
import analytics from '../analytics/component.js';

const el = document.createElement('div');
el.className='app popup_container';

const popup = new Popup();

const popup_viewer = new PopupViewer();

el.appendChild(popup.view);
el.appendChild(popup_viewer.view);

psl_actions.add('popups.close',()=>{
	el.classList.remove('open');
});

psl_actions.add('popups.hide.viewer',()=>{
	popup_viewer.view.classList.remove('open');
	if(popup.view.style.display==='none'){
		el.classList.remove('open');
	}
});

el.addEventListener('click',(e)=>{
	if(!window.matchMedia('(max-width: 768px)').matches) return;
	if(!el.classList.contains('open')) return;
	if(popup_viewer.view.classList.contains('open')){
		if(popup_viewer.view.contains(e.target)) return;
		psl_actions.fire('popups.hide.viewer');
	} else {
		if(popup.view.contains(e.target)) return;
		psl_actions.fire('popups.close');
	}
});

psl_actions.add('popups.show',(e,uid)=>{
	let popup_data = data.popups.find(popup_data=>popup_data.uid===uid);

	if(!popup_data) return;

	analytics.track_popup_open(uid);

	switch(popup_data.type){
		case 'regular':
			popup.render(popup_data);
			popup.view.style.display='';

			popup_viewer.view.classList.remove('open');
		break;
		case 'viewer':
			popup.view.style.display='none';

			popup_viewer.render(popup_data);
			popup_viewer.view.classList.add('open');
		break;
	}

	el.classList.add('open');
});

psl_actions.add('popups.show.viewer',(e,uid)=>{
	let popup_data = data.popups.find(popup_data=>popup_data.uid===uid);

	if(!popup_data) return;

	popup_viewer.render(popup_data);
	popup.view.style.display='';

	el.classList.add('open');
});

psl_actions.add('popups.show.viewer_from_regular',(e,i)=>{
	let viewer_data=popup.data.viewer;

	viewer_data.list=viewer_data.list.filter(el=>el.img||el.video);

	if(viewer_data.list.length===0) return;

	popup_viewer.render(viewer_data,i);

	popup_viewer.view.classList.add('open');

});

state.events.on('reinit',()=>{
	popup_viewer.view.classList.remove('open');
	el.classList.remove('open');
});

document.body.appendChild(el);
